// 本地数据存储
// const store = window.localStorage;
const store = window.sessionStorage;

export default Storage = {
    get: function (name) { //根据key获取
        if (!store) {
            this.noSupport();
            return;
        };
        try {
            let str = store.getItem(name);
            if (str == null) {
                return null;
            } else {
                return JSON.parse(str);
            };
        } catch (error) {
            console.error(error);
        }
    },
    set: function (name, value) {  //key value
        if (!store) {
            this.noSupport();
            return;
        };
        if (name == null || value == null) {
            return;
        };
        try {
            store.setItem(name, JSON.stringify(value));

        } catch (error) {
            console.error(error);
        }
    },
    remove: function (name) {  //更具主键删除
        if (!store) {
            this.noSupport();
            return;
        };
        store.removeItem(name);
    },
    clearAll: function () {    //清空当前端口下的storage
        if (!store) {
            this.noSupport();
            return;
        };
        store.clear();
    },
    noSupport: function () {
        alert('浏览器太旧，不支持storage，请安装新版本浏览器');
    }
}